import { Injectable } from '@angular/core';
import { IDashboardItems, IGlossary, IHyperlink, IReport, ISummaryReport } from '@shared/interfaces';
import { LocalService } from '@shared/services/local.service';

@Injectable({
    providedIn: 'root'
})
export class CacheService {
    activeReport: IReport;
    reports: IReport[];
    glossary: IGlossary[];
    hyperlinks: IHyperlink[];
    summaryReports: ISummaryReport[];

    constructor(private localService: LocalService) {}

    private _homeItems: IDashboardItems;

    get homeItems(): IDashboardItems {
        return this._homeItems ? this._homeItems : this.localService.get('home_items');
    }

    set homeItems(val: IDashboardItems) {
        this._homeItems = val;
        this.localService.set('home_items', val);
    }
}
